<template>
  <b-modal
    v-model="showLocal"
    @hidden="hide"
    dialog-class="gallery-modal"
    centered
    no-close-on-esc
    no-close-on-backdrop
    hide-footer
    hide-header
    size="lg"
  >
    <div class="d-flex justify-content-end">
      <button
        type="button"
        class="bg-transparent p-0 border-0"
        @click.prevent="close()"
      >
        <i class="ri-close-large-line"></i>
      </button>
    </div>

    <section class="mt-4">
        <ShareUrl />
    </section>
  </b-modal>
</template>


<script>
import {
  ModalMixin
} from "wize-admin";

import ShareUrl from "./ShareUrl.vue";

export default {
  name: "ShareBrandModal",
  mixins: [ModalMixin],
  data() {
    return {
    };
  },
  components: {
    ShareUrl
  },
  methods: {
    close() {
      this.hide();
    }
  },
};
</script>
<style lang="stylus">
</style>